import {
  CCACompleteResponse,
  CCAGetQuestionResponse,
  CCAStartResponse,
  CCASubmitAnswerRequest,
  CCASubmitAnswerResponse,
  CCATokenValidationResponse,
  CCAVideoPresignResponse,
} from '../types/cca_candidate_types';
import { rtkApi } from './rtkApi';

export const ccaCandidateApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    validateCCAToken: builder.query<CCATokenValidationResponse, string>({
      query: (token) => `/cca/t/${token}`,
    }),

    startCCAAssessment: builder.mutation<CCAStartResponse, string>({
      query: (token) => ({
        url: `/cca/t/${token}/start`,
        method: 'POST',
      }),
    }),

    // seq is used to create unique cache keys so each question fetch hits the server
    getCCACurrentQuestion: builder.query<
      CCAGetQuestionResponse,
      { token: string; seq: number }
    >({
      query: ({ token }) => `/cca/t/${token}/question`,
      keepUnusedDataFor: 0,
    }),

    submitCCAAnswer: builder.mutation<
      CCASubmitAnswerResponse,
      { token: string; body: CCASubmitAnswerRequest }
    >({
      query: ({ token, body }) => ({
        url: `/cca/t/${token}/answer`,
        method: 'POST',
        body,
      }),
    }),

    getVideoPresignUrl: builder.mutation<
      CCAVideoPresignResponse,
      { token: string; config_question_id: string }
    >({
      query: ({ token, config_question_id }) => ({
        url: `/cca/t/${token}/video-presign?config_question_id=${config_question_id}`,
        method: 'POST',
      }),
    }),

    completeCCAAssessment: builder.mutation<CCACompleteResponse, string>({
      query: (token) => ({
        url: `/cca/t/${token}/complete`,
        method: 'POST',
      }),
    }),

    // Candidate-accessible storage URL — uses CCA token auth, not admin Bearer
    getCandidateStorageUrl: builder.query<
      { url: string },
      { token: string; filePath: string }
    >({
      query: ({ token, filePath }) =>
        `/cca/t/${token}/storage?file_path=${encodeURIComponent(filePath)}`,
    }),
  }),
  overrideExisting: false,
});

export const {
  useValidateCCATokenQuery,
  useStartCCAAssessmentMutation,
  useLazyGetCCACurrentQuestionQuery,
  useSubmitCCAAnswerMutation,
  useGetVideoPresignUrlMutation,
  useCompleteCCAAssessmentMutation,
  useGetCandidateStorageUrlQuery,
} = ccaCandidateApi;
